export default __webpack_public_path__ + "static/media/cartaz-entidades.162a8297.png";